
import React from 'react'
import { ImageOrientationType } from '../helper/enums';
import { getImageUrlFormat_16_9_600, getImageUrlFormat_9_16_600 } from '../helper/images';
import { ImageTeaserEntry } from '../helper/interfaces';
import { getLinkObjectFromTeaser } from '../helper/link';
import { TeaserData } from './teaser'
import CustomImage from './ui/Image';
import { Link2 } from "react-feather";

export default function TeaserImage(data: TeaserData) {
  const teaser = data.teaser
  const image = (teaser as ImageTeaserEntry).image
  const linkObject =getLinkObjectFromTeaser(teaser)

  const imageUrl = image ? ((image.alignment !=  ImageOrientationType.Portrait) ? getImageUrlFormat_16_9_600(image) : 
          getImageUrlFormat_9_16_600(image)) : null;

  const imageClass = image ? ((image.alignment !=  ImageOrientationType.Portrait) ? "aspect-w-16 aspect-h-9" : "aspect-w-9 aspect-h-16") : '';
  
  return (
    <React.Fragment>
     
        <div className="teaser article-title-image-wrapper">
        {linkObject.externalLink && imageUrl && image &&
          <a className="teaser-image-link" href={linkObject.externalLink} target="_blank" rel="noopener noreferrer">
              <div className={`article-title-image ${imageClass}`}>
                <CustomImage
                    src={imageUrl}
                    alt={image.title}
                    fill
                    className="object-cover"
                  />
              </div>
              <div className="teaser-image-icon">
                <Link2 />
              </div>
            </a>
          }
          {!linkObject.externalLink && imageUrl && image &&
            <div className={`article-title-image ${imageClass}`}>
              <CustomImage
                  src={imageUrl}
                  alt={image.title}
                  fill
                  className="object-cover"
                />
            </div>            
          }
          {image && (image.subline || image.credit) &&
            <div className="article-title-image-meta">
              {image.subline}
              <span className="article-title-image-meta-credit"> &copy; {image.credit}</span>
            </div>
          }
        </div>
    </React.Fragment>
  )
}